export default __webpack_public_path__ + "static/media/ES.162b030b.svg";